const styles = {
  card: {
    marginTop: '1em',
  },
  button: {
    margin: '1em 0',
  },
};

export default styles;
